export function getTenantQuickStatusAction(status) {
  if (status === "active") return { nextStatus: "suspended", label: "Suspend tenant", dangerous: true };
  if (status === "suspended") return { nextStatus: "active", label: "Activate tenant", dangerous: false };
  return null;
}
